import {
  Button,
  TextField,
  MenuItem,
  Typography,
  Box,
  Popover,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import axios from "axios";

import { updateEntityAddress } from "../../store/structure/actions";
import { SketchPicker } from "react-color";
import { Add, FormatColorFill, Remove } from "@mui/icons-material";
import { showSuccess } from "../toastify";

const LetterStyle = (props) => {
  const { loading, letterCustomization } = props;
  const dispatch = useDispatch();
  const [colorPickerAnchor, setColorPickerAnchor] = useState(null);
  const [currentColorField, setCurrentColorField] = useState(null);
  const [formData, setFormData] = useState({
    headingBorderColor:
      letterCustomization?.styles?.headingBorderColor || "rgb(7, 142, 206)",
    footerBorderColor:
      letterCustomization?.styles?.footerBorderColor || "#8b572a",
    headingBorderSize: +letterCustomization?.styles?.headingBorderSize || 2,
    footerBorderSize: +letterCustomization?.styles?.footerBorderSize || 3,
    fontSize: letterCustomization?.styles?.fontSize || "16",
    fontFamily: letterCustomization?.styles?.fontFamily || "Times New Roman",
    lineSpacing: letterCustomization?.styles?.lineSpacing || "1.5",
    lineHeight: letterCustomization?.styles?.lineHeight || "1.5",
    textAlign: letterCustomization?.styles?.textAlign || "justify",
  });
  const [isSaving, setIsSaving] = useState(false);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleColorPickerOpen = (event, field) => {
    setColorPickerAnchor(event.currentTarget);
    setCurrentColorField(field);
  };

  const handleColorChange = (color) => {
    setFormData({ ...formData, [currentColorField]: color.hex });
  };

  const handleColorPickerClose = () => {
    setColorPickerAnchor(null);
    setCurrentColorField(null);
  };
  const handleBorderSizeChange = (field, delta) => {
    setFormData((prev) => ({
      ...prev,
      [field]: Math.max(1, prev[field] + delta),
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const styles= JSON.stringify(formData);
      const params={
        styles: styles,
        entitySectorId:letterCustomization?.entity?.entitySectorId || "",
        letterId:letterCustomization?.entity?.letterId || ""
      }
      // console.log(formData);
      submit(params);
    } catch (error) {
      console.error("Error saving settings", error);
    }
  };
  const submit = async (params) => {
    try {
      setIsSaving(true);

      const { data } = await axios.post(
        "/api/structure/letter-styles",
        params
      );
      dispatch({
        type: "SET_LETTER_CUSTOMIZATION",
        data: data,
      });
      showSuccess("Saved");

      setIsSaving(false);
    } catch (error) {
      setIsSaving(false);
    }
  };

  return (
    <>
      <Box p={3} mx="auto">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <TextField
              size="small"
              className="w-100"
              label="Font Size (px)"
              type="number"
              name="fontSize"
              value={formData.fontSize}
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <TextField
              size="small"
              className="w-100"
              select
              label="Font Family"
              name="fontFamily"
              value={formData.fontFamily}
              onChange={handleChange}
            >
              <MenuItem value="Ronnia">Ronnia</MenuItem>
              <MenuItem value="Arial">Arial</MenuItem>
              <MenuItem value="Times New Roman">Times New Roman</MenuItem>
              <MenuItem value="Courier New">Courier New</MenuItem>
              <MenuItem value="Verdana">Verdana</MenuItem>
            </TextField>
          </div>
          <div className="mb-3">
            <TextField
              size="small"
              className="w-100"
              label="Line Spacing"
              type="number"
              step="0.1"
              name="lineSpacing"
              value={formData.lineSpacing}
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <TextField
              size="small"
              className="w-100"
              label="Line Height"
              type="number"
              step="0.1"
              name="lineHeight"
              value={formData.lineHeight}
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <TextField
              size="small"
              className="w-100"
              select
              label="Text Align"
              name="textAlign"
              value={formData.textAlign}
              onChange={handleChange}
            >
              <MenuItem value="left">Left</MenuItem>
              <MenuItem value="center">Center</MenuItem>
              <MenuItem value="right">Right</MenuItem>
              <MenuItem value="justify">Justify</MenuItem>
            </TextField>
          </div>

          <div className="row">
            <div className="col-12">
              <Box mb={2}>
                <Typography>
                  Heading Border Color:
                  <div className="row my-2">
                    <div className="col-7">
                      <div
                        className="mt-3"
                        style={{
                          backgroundColor: "#078ece",
                          height: `${formData.headingBorderSize}px`,
                          border: `${formData.headingBorderSize}px solid ${formData.headingBorderColor}`,
                          borderRadius: "2px",
                        }}
                      ></div>{" "}
                    </div>
                    <div className="col-3">
                      <Button
                        className="mx-1"
                        variant="outlined"
                        size="small"
                        color="error"
                        style={{ width: "50px" }}
                        onClick={() =>
                          handleBorderSizeChange("headingBorderSize", -1)
                        }
                      >
                        <Remove />
                      </Button>
                      <Button
                        className="mx-1"
                        style={{ width: "50px" }}
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={() =>
                          handleBorderSizeChange("headingBorderSize", 1)
                        }
                      >
                        <Add />
                      </Button>
                    </div>
                    <div className="col-2">
                      <IconButton
                        onClick={(e) =>
                          handleColorPickerOpen(e, "headingBorderColor")
                        }
                        sx={{
                          backgroundColor: !![
                            "#fff",
                            "#ffff",
                            "#ffffff",
                          ].includes(
                            formData.headingBorderColor.toLocaleLowerCase()
                          )
                            ? "rgb(7, 142, 206)"
                            : formData.headingBorderColor,
                          borderRadius: "50%",
                          width: 36,
                          height: 36,
                          ml: 1,
                        }}
                      >
                        <FormatColorFill sx={{ color: "#fff" }} />
                      </IconButton>
                    </div>
                  </div>
                </Typography>
              </Box>
            </div>

            <div className="col-12">
              <Box mb={2}>
                <Typography>
                  Footer Border Color:
                  <div className="row my-2">
                    <div className="col-7">
                      <div
                        className="mt-3"
                        style={{
                          backgroundColor: "#078ece",
                          height: `${formData.footerBorderSize}px`,
                          border: `${formData.footerBorderSize}px solid ${formData.footerBorderColor}`,
                          borderRadius: "2px",
                        }}
                      ></div>{" "}
                    </div>
                    <div className="col-3">
                      <Button
                        variant="outlined"
                        size="small"
                        color="error"
                        className="mx-1"
                        onClick={() =>
                          handleBorderSizeChange("footerBorderSize", -1)
                        }
                      >
                        <Remove />
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        color="primary"
                        className="mx-1"
                        onClick={() =>
                          handleBorderSizeChange("footerBorderSize", 1)
                        }
                      >
                        <Add />
                      </Button>
                    </div>
                    <div className="col-2">
                      <IconButton
                        onClick={(e) =>
                          handleColorPickerOpen(e, "footerBorderColor")
                        }
                        sx={{
                          backgroundColor: !![
                            "#fff",
                            "#ffff",
                            "#ffffff",
                          ].includes(
                            formData.footerBorderColor.toLocaleLowerCase()
                          )
                            ? "rgb(7, 142, 206)"
                            : formData.footerBorderColor,
                          borderRadius: "50%",
                          width: 36,
                          height: 36,
                          ml: 1,
                        }}
                      >
                        <FormatColorFill sx={{ color: "#fff" }} />
                      </IconButton>
                    </div>
                  </div>
                </Typography>
              </Box>
            </div>
          </div>
          <Popover
            open={Boolean(colorPickerAnchor)}
            anchorEl={colorPickerAnchor}
            onClose={handleColorPickerClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <SketchPicker
              color={formData[currentColorField]}
              onChange={handleColorChange}
            />
          </Popover>
          <Box
            mt={4}
            p={2}
            style={{
              fontSize: `${formData.fontSize}px`,
              fontFamily: formData.fontFamily,
              lineHeight: formData.lineHeight,
              textAlign: formData.textAlign,
              letterSpacing: `${formData.lineSpacing}px`,
            }}
          >
            <span>This is a preview of the customized letter.</span>
          </Box>
          <div>
            <div className="col-12 d-flex justify-content-center py-3">
              <button
                disabled={isSaving}
                type="submit"
                className="btn btn-primary text-uppercase px-4"
              >
                {isSaving ? "Wait..." : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Box>
    </>
  );
};

const mapStateToProps = ({ loading, onWait, letterCustomization }) => {
  return {
    loading,
    onWait,
    letterCustomization,
  };
};
export default connect(mapStateToProps, {
  updateEntityAddress,
})(LetterStyle);
